module.exports = __webpack_public_path__ + "static/media/lips.fda25d55.svg";